import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { MatDialog } from '@angular/material/dialog';
import { DeviceTypeSelectDialogComponent } from './device-type-select-dialog/device-type-select-dialog.component';
import { DIALOG_CONFIG } from 'src/app/shared/global-config';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { S3_URL_BASE } from 'src/environments/environment';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

enum ActionTypesEnum {
  CANCEL,
  DIRECTORY,
  CAMERA,
}

@Component({
  selector: 'form-image',
  styleUrls: ['form-image.component.sass'],
  template: `<div
    title="Selecione uma Imagem"
    (click)="typeCes !== typeCesEnum.SHOW ? selectImage() : ''"
    matRipple
    [matRippleDisabled]="this.typeCes === typeCesEnum.SHOW"
    [ngClass]="
      this.typeCes === typeCesEnum.SHOW
        ? 'image-field'
        : 'image-field image-cursor'
    "
    [formGroup]="group"
  >
    <input
      accept="image/*"
      #uploadFile
      (change)="upload($event)"
      type="file"
      style="display:none"
    />
    <input
      type="hidden"
      [formControlName]="config.name"
      [ngModel]="group.get(this.config.name)?.getRawValue()"
    />
    <div class="image-content">
      <img
        class="image-display"
        *ngIf="image || group.get(this.config.name)?.getRawValue()"
        [src]="image ? image : getImgUri()"
      />
      <mat-icon *ngIf="!image" class="icon-display"
        >photo_size_select_actual</mat-icon
      >
    </div>
    <div *ngIf="typeCes !== typeCesEnum.SHOW" class="image-text">
      <p *ngIf="!image">SELECIONE UMA IMAGEM</p>
      <p *ngIf="image">TROCAR IMAGEM</p>
    </div>
  </div>`,
})
export class FormImageComponent implements Field {
  image: any;
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;
  @ViewChild('uploadFile') uploadFile: ElementRef<HTMLElement>;

  constructor(
    public dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) {}

  openDialog() {
    this.dialog
      .open(DeviceTypeSelectDialogComponent, {
        ...DIALOG_CONFIG,
        width: '600px',
      })
      .afterClosed()
      .subscribe((data: any) => {
        if (data.image) {
          this.image = data.image;
          this.group.get(this.config.name)?.patchValue(data.image);
        }
      });
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  // APENAS PARA MOBILE
  async upload(event: any) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;

    if (fileList) {
      if (fileList[0]) {
        this.image = await new GlobalUtils().getBase64Url(fileList);
        this.group.get(this.config.name)?.patchValue(this.image);
      } else {
        this.image = fileList[0];
      }
    }
  }

  getImgUri() {
    if (
      this.group.get(this.config.name)?.getRawValue().indexOf('base64') == -1
    ) {
      return `${S3_URL_BASE}${this.group.get(this.config.name)?.getRawValue()}`;
    } else {
      return this.group.get(this.config.name)?.getRawValue();
    }
  }

  public selectImage() {
    const isMobile = this.deviceService.isMobile();
    if (isMobile) this.uploadFile.nativeElement.click();
    if (!isMobile) this.openDialog();
  }
}
